const RrIconButton = ({ onClick, children }) => {
  return (
    <div className="rr-iconbutton" onClick={onClick}>
      {children}
    </div>
  )
}

export default RrIconButton
